exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".miniFont[data-v-4d54c574]{font-size:10pt;font-family:Roboto,sans-serif}.cadre[data-v-4d54c574]{cursor:pointer!important}.form-check-label[data-v-4d54c574]{letter-spacing:-.5px}", ""]);

// exports
